/* ===== Custom GNB Localization Dropdown ===== */
/*
 * 언어/통화 드롭다운의 열기/닫기 동작만 담당합니다.
 * 실제 선택 제출은 <button type="submit" name="locale_code|country_code">가
 * Shopify {% form 'localization' %} 를 통해 직접 처리하므로 여기서는 다루지 않습니다.
 *
 * - desktop: 버튼 클릭으로 플로팅 패널 토글, 바깥 클릭/ESC 로 닫힘
 * - mobile : 드로어 내부 인라인 아코디언 토글 (바깥 클릭으로 닫지 않음)
 */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.gnbLocInitialized === 'true') return;
    root.dataset.gnbLocInitialized = 'true';

    const toggle = root.querySelector('[data-gnb-loc-toggle]');
    const panel = root.querySelector('[data-gnb-loc-panel]');
    if (!toggle || !panel) return;

    const isMobile = root.dataset.variant === 'mobile';

    // 데스크탑: 패널이 position:fixed 이므로 토글 버튼 기준으로 위치를 계산한다.
    // (헤더의 overflow:hidden 을 피하기 위함)
    const positionPanel = () => {
      const rect = toggle.getBoundingClientRect();
      panel.style.top = `${Math.round(rect.bottom + 8)}px`;
      let left = Math.round(rect.right - panel.offsetWidth);
      if (left < 8) left = 8;
      panel.style.left = `${left}px`;
    };

    const open = () => {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      if (!isMobile) {
        positionPanel();
        document.addEventListener('click', onOutsideClick, true);
        document.addEventListener('keydown', onKeyDown);
        window.addEventListener('scroll', onViewportChange, { passive: true });
        window.addEventListener('resize', onViewportChange);
      }
    };

    const close = () => {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (!isMobile) {
        document.removeEventListener('click', onOutsideClick, true);
        document.removeEventListener('keydown', onKeyDown);
        window.removeEventListener('scroll', onViewportChange);
        window.removeEventListener('resize', onViewportChange);
      }
    };

    // 스크롤/리사이즈 시 fixed 패널이 따라오지 않으므로 닫는다.
    const onViewportChange = () => {
      if (!panel.hidden) close();
    };

    const onOutsideClick = (event) => {
      if (!root.contains(event.target)) close();
    };

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        close();
        toggle.focus();
      }
    };

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      if (panel.hidden) {
        open();
      } else {
        close();
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-gnb-localization]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Re-init after Shopify theme editor section reloads.
  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
